import { render, staticRenderFns } from "./enterThePS.vue?vue&type=template&id=913da1aa&scoped=true&"
import script from "./enterThePS.vue?vue&type=script&lang=js&"
export * from "./enterThePS.vue?vue&type=script&lang=js&"
import style0 from "@/assets/components.scss?vue&type=style&index=0&id=913da1aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "913da1aa",
  null
  
)

export default component.exports